import ThreadListMember from './ThreadListMember';
import { buildPartialThreadListMember } from './buildPartialThreadListMember';
export const buildThreadListMember = props => ThreadListMember(buildPartialThreadListMember(props));